import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { IMAGES, COMPANY } from "@/data/siteData";

const stats = [
  { value: "A", label: "BBB Rating", id: "stat-bbb" },
  { value: "6+", label: "Manufacturer Partnerships", id: "stat-partners" },
  { value: "4", label: "Metro Areas Served", id: "stat-areas" },
];

export const About = () => (
  <section data-testid="home-about" className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
    <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
      <Reveal className="lg:col-span-5">
        <div className="relative">
          <img src={IMAGES.about} alt="Technician inspecting rooftop solar panels" className="aspect-[4/5] w-full rounded-2xl object-cover" />
          <div className="absolute -bottom-6 -right-4 hidden rounded-2xl border border-border bg-background p-6 shadow-sm sm:block lg:-right-10">
            <p className="eyebrow text-primary">Credentials</p>
            <p className="mt-2 font-display text-2xl font-light text-foreground">NABCEP Licensed</p>
            <p className="mt-1 text-sm text-muted-foreground">BBB Accredited &middot; A Rating</p>
          </div>
        </div>
      </Reveal>

      <div className="lg:col-span-7 lg:pl-8">
        <Reveal>
          <SectionHeading
            eyebrow="Our Vision &amp; Mission"
            title="Reliable, long-term care for solar systems — even when the original provider is gone."
          />
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 space-y-5 text-base font-light leading-relaxed text-muted-foreground md:text-lg">
            <p>
              <strong className="font-medium text-foreground">{COMPANY.name}</strong> is a solar systems operations and
              maintenance company serving residential homeowners and solar installation enterprises. We fill the operational
              and maintenance gaps left behind when original installers exit the market, when manufacturers need a trusted
              regional service partner, or when an in-house team simply needs more capacity.
            </p>
            <p>
              Our technicians are certified installers and servicing partners with leading manufacturers and NABCEP
              licensed. Every job is scoped, documented and commissioned to the same standard — because the goal is not a
              one-time fix, but reliable, long-term care that keeps your system producing for decades. For solar businesses,
              we extend that same discipline into technical training and quality control.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <dl className="mt-12 grid grid-cols-3 gap-6 border-t border-border pt-10">
            {stats.map((s) => (
              <div key={s.label} data-testid={s.id}>
                <dt className="font-display text-4xl font-light text-primary sm:text-5xl">{s.value}</dt>
                <dd className="mt-2 text-xs uppercase tracking-[0.15em] text-muted-foreground">{s.label}</dd>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </div>
  </section>
);
